const schedules = {
	types: ['Time', 'Sunrise', 'Sunset'],
	mode: 'Time',
	commands: ['on', 'off'],
	selection: 'on',
	days: [0, 1, 2, 3, 4, 5, 6],
	time: '00:00',
};

const duration = {
	duration: 0,
};

const optional = true;

const colorTemperature = {
	colorTemperature: 2900,
};
const deviceWithMotion = {
	commands: ['activate motion detection', 'deactivate motion detection'],
	selection: 'activate motion detection',
};
const brightness = {
	brightness: undefined,
};

export const devicesConfigSchedules = {
	/* Relays */
	'SHUNI-1': {
		schedules: {
			...schedules,
		},
	},

	'SHPLG-1': {
		schedules: {
			...schedules,
		},
	},

	'SHPLG-S': {
		schedules: {
			...schedules,
		},
	},

	'SHPLG-U1': {
		schedules: {
			...schedules,
		},
	},

	'SHPLG2-1': {
		schedules: {
			...schedules,
		},
	},

	'SHSK-1': {
		schedules: {
			...schedules,
		},
	},

	'SHSW-1': {
		schedules: {
			...schedules,
		},
	},

	'SHSW-1S': {
		schedules: {
			...schedules,
		},
	},

	'SHSW-L': {
		schedules: {
			...schedules,
		},
	},

	'SHSW-21': {
		schedules: {
			...schedules,
		},
	},

	'SHSW-22': {
		schedules: {
			...schedules,
		},
	},

	'SHSW-25': {
		schedules: {
			...schedules,
		},
	},

	'SHSW-44': {
		schedules: {
			...schedules,
		},
	},

	'SHSW-PM': {
		schedules: {
			...schedules,
		},
	},

	'SHAIR-1': {
		schedules: {
			...schedules,
		},
	},

	'SHEM-1-relay': {
		schedules: {
			...schedules,
		},
	},

	/* Emeters */
	'SHEM-3': {
		schedules: {
			...schedules,
		},
	},

	SHEM: {
		schedules: {
			...schedules,
		},
	},

	/* Sensors */
	'SHSEN-1': {},

	'SHGS-1': {},

	'SHMOS-01': {
		schedules: {
			...schedules,
			// ...device_with_motion//not needed, because commands are on and off
		},
	},
	'SHMOS-02': {
		schedules: {
			...schedules,
			// ...device_with_motion//not needed, because commands are on and off
		},
	},

	'SHSM-01': {},

	'SHHT-1': {},

	'SHDW-1': {},

	'SHDW-2': {},

	'SHWT-1': {},

	/* Lights */
	'SHCL-255': {
		schedules: {
			...schedules,
		},
	},

	'SHBLB-1': {
		schedules: {
			...schedules,
			...brightness,
			optional,
		},
	},

	'SHRGBWW-01': {
		schedules: {
			...schedules,
			...brightness,
			optional,
		},
	},

	SHRGBW2: {
		schedules: {
			...schedules,
			...brightness,
			optional,
		},
	},

	'SH2LED-1': {
		schedules: {
			...schedules,
			...brightness,
			optional,
		},
	},

	'SHDM-1': {
		schedules: {
			...schedules,
			...brightness,
			...duration,
			optional,
		},
	},

	'SHDM-2': {
		schedules: {
			...schedules,
			...brightness,
			...duration,
			optional,
		},
	},

	'SHDIMW-1': {
		schedules: {
			...schedules,
			...brightness,
			...duration,
			optional,
		},
	},

	'SHVIN-1': {
		schedules: {
			...schedules,
			...brightness,
			optional,
		},
	},

	'SHBDUO-1': {
		schedules: {
			...schedules,
			...brightness,
			...colorTemperature,
			...duration,
			optional,
		},
	},

	'SHCB-1': {
		schedules: {
			...schedules,
			...brightness,
			optional,
		},
	},

	/* Inputs reader */
	'SHBTN-1': {},

	'SHBTN-2': {},

	'SHIX3-1': {},

	/* Narrow-band devices */
	PLG1NB: {},

	SMK1NB: {},

	DS1NB: {},

	MS1NB: {},

	HT1NB: {},

	WS1NB: {},

	'IR_REM-0': {},

	'IR_REM-1-remote': {},

	'SHSPOT-1': {},

	SHPSW04P: {
		schedules: {
			...schedules,
		},
	},
};
